import { render, staticRenderFns } from "./DisconnectSwitch.vue?vue&type=template&id=3d2e3380&scoped=true&"
import script from "./DisconnectSwitch.vue?vue&type=script&lang=js&"
export * from "./DisconnectSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2e3380",
  null
  
)

export default component.exports